__webpack_require__.p = "https://robo-static-qa-obs.momenta.cn/robo-platform-main-fe/";